import { Module } from "vuex";
import { RootState } from "../types";
import { ContractorsState } from "./types";

import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

import { Contractor } from '@/models';

// Default state
export const state: ContractorsState = {
	current: new Contractor(),
	list: [],
	month: undefined,
	search: undefined,
	updates: [],
	currentPage: 1,
  pageLimit: 20,	
}

// User namespaced Vuex modules
const namespaced: boolean = true;

// Module export
const properties: Module<ContractorsState, RootState> = {
	state,
	getters,
	mutations,
	actions,
	namespaced,
}

export default properties;